
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import EingetragenAmVom from '@/components/EingetragenAmVom.vue';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import { ImpfDbImpfstoffEdit } from '@/types/ImpfDbImpfstoff';
    import { VForm } from '@/types/Components';

    @Component({
        components: {
            EingetragenAmVom,
        },
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('impfdb', ['loaders']),
        },
        methods: {
            ...mapActions('impfdb', ['loadImpfstoff', 'updateImpfstoff', 'deleteImpfstoff']),
        },
    })
    export default class ImpfDbImpfstoffeDetail extends Vue {
        @Prop() impfstoff!: ImpfDbImpfstoffEdit;
        @Prop() visible!: boolean;

        public updateImpfstoff!: (impfstoff: ImpfDbImpfstoffEdit) => void;
        public deleteImpfstoff!: (impfstoff: ImpfDbImpfstoffEdit) => void;

        public $refs!: {
            form: VForm;
        };

        public isEdit = false;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.isEdit = this.impfstoff.impfstoffnr !== null;
                this.impfstoff.prevImpfstoffnr = this.impfstoff.impfstoffnr;

                if (this.$refs.form) {
                    this.$refs.form.resetValidation();
                }
            }
        }

        public onClickSave(): void {
            if (this.$refs.form.validate()) {
                this.updateImpfstoff(this.impfstoff);
            }
        }

        public onClickDelete(): void {
            confirmSwal('Löschen', 'Impfstoff endgültig löschen?', 'Löschen', 'Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        this.deleteImpfstoff(this.impfstoff);
                    }
                });
        }
    }
